import { render, staticRenderFns } from "./ThreeWindow.vue?vue&type=template&id=6f52d662&scoped=true&slot-scope=scope&"
import script from "./ThreeWindow.vue?vue&type=script&lang=js&"
export * from "./ThreeWindow.vue?vue&type=script&lang=js&"
import style0 from "./ThreeWindow.vue?vue&type=style&index=0&id=6f52d662&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f52d662",
  null
  
)

export default component.exports